import { render, staticRenderFns } from "./kllk-footer-nav.vue?vue&type=template&id=ced6465c&scoped=true&"
import script from "./kllk-footer-nav.vue?vue&type=script&lang=js&"
export * from "./kllk-footer-nav.vue?vue&type=script&lang=js&"
import style0 from "./kllk-footer-nav.vue?vue&type=style&index=0&id=ced6465c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced6465c",
  null
  
)

export default component.exports